import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseButtonDirective } from '@shared/base-button.directive';
import { BaseIconDirective } from '@shared/base-icon.directive';
import { BaseLinkDirective } from '@shared/base-link.directive';
import { WellnessCoverageModalComponent } from '@shared/wellness-coverage-modal/wellness-coverage-modal.component';

import { AutoRenewalModalComponent } from './auto-renewal-modal/auto-renewal-modal.component';
import { BannerComponent } from './banner/banner.component';

import { BaseErrorModalComponent } from './base-error-modal/base-error-modal.component';
import { CoveragesModalComponent } from './coverages-modal/coverages-modal.component';
import { CustomInputDirective } from './custom-input.directive';
import { DisableAutocompleteDirective } from './disable-autocomplete.directive';
import { ElectronicDisclosureModalComponent } from './electronic-disclosure-modal/electronic-disclosure-modal.component';
import { EmbracePolicyModalComponent } from './embrace-policy-modal/embrace-policy-modal.component';
import { EpiControlDirective } from './epi-control.directive';
import { EpiRadioControlDirective } from './epi-radio-control.directive';
import { HideProdDirective } from './hide-prod.directive';
import { InputMaskDirective } from './input-mask.directive';
import { MaterialModule } from './material.module';
import { PaymentScheduleModalComponent } from './payment-schedule-modal/payment-schedule-modal.component';
import { PolicyOptionModalComponent } from './policy-option-modal/policy-option-modal.component';
import { PrivacyPolicyModalComponent } from './privacy-policy-modal/privacy-policy-modal.component';
import { RemovePetModalComponent } from './remove-pet-modal/remove-pet-modal.component';
import { StateFraudModalComponent } from './state-fraud-modal/state-fraud-modal.component';
import { TermsOfServiceModalComponent } from './terms-of-service-modal/terms-of-service-modal.component';
import { ZipSearchModalComponent } from './zip-search-modal/zip-search-modal.component';

@NgModule({
	declarations: [
		CustomInputDirective,
		BaseButtonDirective,
		BaseLinkDirective,
		BaseIconDirective,
		WellnessCoverageModalComponent,
		InputMaskDirective,
		EpiControlDirective,
		EpiRadioControlDirective,
		RemovePetModalComponent,
		TermsOfServiceModalComponent,
		ElectronicDisclosureModalComponent,
		PaymentScheduleModalComponent,
		CoveragesModalComponent,
		ZipSearchModalComponent,
		BaseErrorModalComponent,
		HideProdDirective,
		DisableAutocompleteDirective,
		PrivacyPolicyModalComponent,
		EmbracePolicyModalComponent,
		PolicyOptionModalComponent,
		StateFraudModalComponent,
		BannerComponent,
		AutoRenewalModalComponent
	],
	imports: [
		CommonModule,
		MaterialModule,
		CdkTableModule,
		ReactiveFormsModule,
	],
	exports: [
		CustomInputDirective,
		BaseButtonDirective,
		BaseLinkDirective,
		BaseIconDirective,
		InputMaskDirective,
		EpiControlDirective,
		EpiRadioControlDirective,
		MaterialModule,
		HideProdDirective,
		DisableAutocompleteDirective,
		PolicyOptionModalComponent,
		BannerComponent,
		AutoRenewalModalComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
